// Resources: where things live. Company links, then each team's plan docs and files (edited on that team's page).
import { useState } from "react";
import { ExternalLink, FileText, Folder } from "lucide-react";
import { api, Drawer, Loading, useLoad, useMe } from "./lib";
import { fromLines, toLines } from "./dept";

function Links({ items }: { items: any[] }) {
  return (
    <div className="files-grid">
      {items.map((f, i) => (
        <a key={i} className="file-link" href={f.href} target="_blank" rel="noreferrer"><FileText size={16} /><span>{f.label}</span></a>
      ))}
    </div>
  );
}

export function Resources() {
  const { toast } = useMe();
  const { data, error, reload } = useLoad<any>("/api/resources");
  const [editing, setEditing] = useState(false);
  if (!data) return <div className="page"><Loading error={error} /></div>;
  return (
    <div className="page">
      <section className="card stack">
        <div className="row between">
          <div className="row" style={{ gap: 8 }}><Folder size={18} className="muted" /><h2>Company</h2></div>
          {data.can_edit_company && <button className="btn sm" onClick={() => setEditing(true)}>Edit</button>}
        </div>
        {data.company.length ? <Links items={data.company} /> : <span className="muted small">No company links yet.</span>}
      </section>
      {data.departments.map((d: any) => (
        <section key={d.area} className="card stack">
          <div className="row between">
            <h2>{d.label}</h2>
            <a className="btn sm" href={d.href}>{d.can_edit ? "Edit on the page" : "Open the page"} <ExternalLink size={13} /></a>
          </div>
          {d.links.length + d.files.length ? <Links items={[...d.links, ...d.files]} /> : <span className="muted small">Nothing linked yet. Anyone who edits {d.label} can add the plan docs and files under Plan and Files on its page.</span>}
        </section>
      ))}
      {editing && (
        <Drawer title="Company links" sub={<span className="muted small">Everyone signed in sees these.</span>} onClose={() => setEditing(false)}>
          <form
            className="form"
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                await api("/api/resources/company", { method: "PUT", body: { links: fromLines(String(new FormData(e.currentTarget).get("links"))) } });
                toast("Saved");
                setEditing(false);
                reload();
              } catch (err: any) {
                toast(err.message, true);
              }
            }}
          >
            <label className="field">Links<textarea className="input" name="links" rows={10} defaultValue={toLines(data.company)} /></label>
            <p className="muted small" style={{ margin: 0 }}>One per line: a name, a bar, then the https link.</p>
            <div className="row"><button className="btn primary">Save</button></div>
          </form>
        </Drawer>
      )}
    </div>
  );
}
